import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import { LinkContext } from "../../LinkProvider";

import desktopImg from "../../img/AboutUs/rec3.webp";
import mobileImg from "../../img/AboutUs/rec3.webp";
import Fade from 'react-reveal/Fade';

function BuiltFor() {
  const { link } = useContext(LinkContext);
  const { t } = useTranslation();

  return (
    <section className="mt-[80px] xl:mt-[160px]">
      {/* Desktop */}
      <div className="hidden xl:block">
        <div className="relative mx-auto h-[435px] max-w-[1220px] overflow-hidden bg-[#daebfc]">
          {/* Right image */}
          <div className="absolute right-0 top-0 h-[435px] w-[592px] overflow-hidden">
            <img src={desktopImg} alt="" className="h-full w-full object-cover" />
          </div>
          {/* Left text */}
          <Fade bottom>
          <div className="absolute left-[46px] top-[57px] flex w-[443px] flex-col gap-[20px]">
            <div className="flex flex-col gap-[20px]">
              <h2 className="font-['Nunito_Sans'] text-[32px] font-black leading-[1.2] text-[#3273b4]">
                {t("about.built.title")}
              </h2>
              <span className="block h-[4px] w-[104px] bg-[#05193a]" />
              <div className="flex flex-col gap-[15px]">
                <p className="font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
                  {t("about.built.text1")}
                </p>
                <p className="font-['Nunito_Sans'] text-[16px] font-light leading-[1.5] text-[#05193a]">
                  {t("about.built.text2")}
                </p>
              </div>
            </div>
            <a
              href={link}
              className="inline-flex h-[42px] w-fit items-center justify-center rounded-[10px] bg-[#05193a] px-[35px] font-[Inter] text-[16px] font-light capitalize text-white transition-colors hover:bg-[#0d2c60]"
            >
              {t("header.openAccount")}
            </a>
          </div>
          </Fade>
        </div>
      </div>

      {/* Mobile */}
      <Fade bottom>
      <div className="xl:hidden">
        <div className="overflow-hidden">
          <img src={mobileImg} alt="" className="h-[185px] w-full object-cover" />
        </div>
        <div className="bg-[#daebfc] px-[20px] pb-[40px] pt-[30px]">
          <div className="flex flex-col gap-[15px]">
            <h2 className="font-['Nunito_Sans'] text-[26px] font-black leading-[1.5] text-[#3273b4]">
              {t("about.built.title")}
            </h2>
            <span className="block h-[4px] w-[104px] bg-[#05193a]" />
            <p className="font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
              {t("about.built.text1")}
            </p>
            <p className="font-['Nunito_Sans'] text-[14px] font-light leading-[1.5] text-[#05193a]">
              {t("about.built.text2")}
            </p>
          </div>
          <a
            href={link}
            className="mt-[30px] inline-flex h-[38px] items-center justify-center rounded-[10px] bg-[#05193a] px-[28px] font-[Inter] text-[14px] font-light capitalize text-white transition-colors hover:bg-[#0d2c60]"
          >
            {t("header.openAccount")}
          </a>
        </div>
      </div>
      </Fade>
    </section>
  );
}

export default BuiltFor;
